import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {GroupService, OrganizationService, ReferenceService} from '../../../apiModule1';
import {AsyncPipe, NgClass, NgStyle} from '@angular/common';
import {map} from 'rxjs/operators';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {organizationResolver} from '../organization.resolver';
import {OnInputChange} from '../../OnInputChange';
import {BehaviorSubject, Observable, of} from 'rxjs';

@Component({
  selector: 'pas-filter-dialog-organization',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    AsyncPipe,
    MatButton,
    NgClass,
    NgStyle,
    MultiSelect2Component
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss','../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  groupService = inject(GroupService);
  organizationService = inject(OrganizationService);


  archiveStatuses: Status[] = []
  groups: Group[] = []
  objects: Group[] = []
  organizations: Organization[] = []

  cbs: { id: number, name: string}[] = []
  searchCbs$ = new BehaviorSubject<string>('');
  filteredCbs$: Observable<{ id: number, name: string}[]> = of([]);

  form = new FormGroup({
    archive: new FormControl(this.data && this.data['statusIds'] || []),
    group: new FormControl(this.data && this.data['organizationGroupIds'] || []),
    object: new FormControl(this.data && this.data['objectGroupIds'] || []),
    organization: new FormControl(this.data && this.data['organizationIds'] || []),
    cbTypeIds: new FormControl(this.data && this.data['cbTypeIds']||[] ),
  })

  dataGroup: OnInputChange<Group>  = new OnInputChange(this.groupService,'apiGroupFilterlistGet', 'organization')
  dataObject: OnInputChange<Group> = new OnInputChange(this.groupService, 'apiGroupFilterlistGet', 'organization')
  dataOrganization: OnInputChange<Organization> = new OnInputChange(this.organizationService, 'apiOrganizationFilterlistGet', 'organization')

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
      this.archiveStatuses = v;
    })


    this.dataOrganization.on().subscribe(v => {
      this.organizations = v;
      this.cdr.markForCheck();
    })

    this.dataGroup.on({object: ['OrganizationGroup']}).subscribe(v => {
      this.groups = v;
      this.cdr.markForCheck();
    })

    this.dataObject.on({object: ['ObjectGroup']}).subscribe(v => {
      this.objects = v;
      this.cdr.markForCheck();
    })

    this.referenceService.apiReferenceCbtypesGet()
      .pipe(map(v => v.values))
      .subscribe((v: { id: number, name: string}[])=>{
        this.cbs = v;
        this.filteredCbs$ = this.searchCbs$.pipe(map(v=>{
          const res = this.cbs.filter(cb => cb.name?.toLowerCase().includes(v.toLowerCase()));
          return res;
        }))
        //--- заполняем form.get('cbTypeIds')
        if(!this.data || !this.data['cbTypeIds']) return;
        const matchedCbs = this.cbs.filter(cb => this.data['cbTypeIds'].includes(cb.id));
        this.form.get('cbTypeIds')?.setValue(matchedCbs, { emitEvent: false });
      })

  }


  onReset(): void {
    this.form.reset();
  }

  onApply() {
    const cbControl = this.form.get('cbTypeIds');
    const cb = !!cbControl?.value
      && !!cbControl.value?.length
      && cbControl.value.map((v: any) => v.id);

    const res = {
      statusIds: this.form.get('archive')!.value,
      organizationGroupIds: this.form.get('group')!.value,
      objectGroupIds: this.form.get('object')!.value,
      organizationIds: this.form.get('organization')!.value,
      cbTypeIds: cb || [],
    }

    this.dialogRef.close(res);
  }

  protected readonly organizationResolver = organizationResolver;
}


